export const GET_NETFLIX_ORIGINALS = 'GET_NETFLIX_ORIGINALS';
export const GET_TRENDING_MOVIES = 'GET_TRENDING_MOVIES';
export const GET_TOPRATED_MOVIES = 'GET_TOPRATED_MOVIES';
export const GET_ACTION_MOVIES = 'GET_ACTION_MOVIES';
export const GET_COMEDY_MOVIES = 'GET_COMEDY_MOVIES';
export const GET_HORROR_MOVIES = 'GET_HORROR_MOVIES';
export const GET_ROMANCE_MOVIES = 'GET_ROMANCE_MOVIES';
export const GET_DOCUMENTARIES_MOVIES = 'GET_DOCUMENTARIES_MOVIES';
export const SET_MOVIE_DETAIL = 'SET_MOVIE_DETAIL';
export const GET_SEARCH_MOVIES = 'GET_SEARCH_MOVIES';
